// src/Store/searchStore.js

import { reactive } from "vue";

const state = reactive({
  searchQuery: "",
});

const setQuery = (query) => {
  state.searchQuery = query;
};

export default {
  state,
  setQuery,
};
